export function Avatar({
  text,
  size = 'small',
  'aria-label': ariaLabel,
}: {
  readonly text: string
  readonly size?: 'small'
  readonly 'aria-label'?: string
}) {
  const px = size === 'small' ? 28 : 32
  return (
    <span
      aria-label={ariaLabel}
      style={{
        width: px,
        height: px,
        borderRadius: '50%',
        background: 'var(--brand-soft)',
        color: 'var(--mauve-700)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      {text}
    </span>
  )
}
